import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { GameImg, MemberSellerVo, PersonalForm, SellerApplyVo, VerificationUrlVo } from '@/api/member/seller-aplication/types';

/**
 * 卖家申请状态
 */
export const getSellerStatus = (query?: any): AxiosPromise<MemberSellerVo> => {
  return request({
    url: '/member/seller/status',
    method: 'get',
    params: query
  });
};

/**
 * 发送邮箱、手机验证码
 **/
export const sendVerifyCode = (data: any) => {
  return request({
    url: '/member/seller/sendVerifyCode',
    method: 'post',
    data
  });
};

/**
 * 验证邮箱、手机验证码
 **/
export const verifyCode = (data: any) => {
  return request({
    url: '/member/seller/verifyBind',
    method: 'post',
    data
  });
};

/**
 * 申请表单业务列表
 */
export const getBusinessList = (query?: any): AxiosPromise<GameImg[]> => {
  return request({
    url: '/member/seller/business',
    method: 'get',
    params: query
  });
};

/**
 *  获取身份验证地址
 */
export const getVerificationUrl = (query: number): AxiosPromise<VerificationUrlVo> => {
  return request({
    url: '/member/shuftiPro/verificationUrl',
    method: 'get',
    params: { type: query }
  });
};

// /**
//  * 获取验证结果
//  **/
export const getVerificationResult = (data: {
  requestSource: number;
  reference: string;
}): AxiosPromise<{ reference: string; flag: number }> => {
  return request({
    url: '/member/shuftiPro/verificationResult',
    method: 'post',
    data
  });
};

/**
 * 提交表单
 **/
export const applyForm = (data: PersonalForm): AxiosPromise<SellerApplyVo> => {
  return request({
    url: '/member/seller/apply',
    method: 'post',
    data
  });
};

/**
 * 获取申请数据
 */
export const getApplyData = (): AxiosPromise<{ sellerType?: number }> => {
  return request({
    url: '/member/seller/info',
    method: 'get'
  });
};
